<template functional>
	<component :is="props.tag" class="card">
		<component :is="props.titleTag" class="card__title">
			{{ props.title }}
		</component>

		<component :is="props.bodyTag" class="card__body">
			<slot/>
		</component>
	</component>
</template>

<script>
	import VueTypes from "vue-types"
	export default {
		props: {
			tag: VueTypes.string.def("div"),
			titleTag: VueTypes.string.def("h1"),
			bodyTag: VueTypes.string.def("div"),
			title: VueTypes.string.isRequired,
		}
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/Card" as *;
</style>